import { useMutation, type UseMutationResult } from "@tanstack/react-query";

import { toast } from "@/components/toast/toast-queue";
import apiClient from "@/lib/api/client";

export type DeleteChatCommentError = {
  error: string;
  message: string;
  statusCode: number;
};

export type CannotDeleteCommentVariant =
  | "feedback-blocked"
  | "permission-denied";

export function getCannotDeleteCommentVariant(
  error: DeleteChatCommentError,
): CannotDeleteCommentVariant | null {
  if (error.statusCode === 403) return "permission-denied";

  if (error.statusCode === 400) return "feedback-blocked";

  return null;
}

export function useDeleteChatComment(): UseMutationResult<
  Response,
  DeleteChatCommentError,
  string
> {
  return useMutation({
    mutationFn: async (batchCommentUuid: string) =>
      apiClient.url(`/stories/chat/${batchCommentUuid}`).delete().res(),
    onError: (error) => {
      console.error("Failed to delete chat comment:", error);
    },
    onSuccess: () => {
      toast.add(
        {
          title: "Message deleted successfully",
          type: "success",
        },
        {
          timeout: 3000,
        },
      );
    },
  });
}
